import { useState, useCallback } from "react";

export function useToggle(
  initialValue: boolean
): [boolean, setTrue: () => void, setFalse: () => void, toggle: () => void] {
  const [value, setValue] = useState(initialValue);

  const setTrue = useCallback(() => setValue(true), []);
  const setFalse = useCallback(() => setValue(false), []);
  const toggle = useCallback(() => setValue((value) => !value), []);

  return [value, setTrue, setFalse, toggle];
}
